<div class="flex-justify-between flex items-center px-4">
    <p class="mt-4 text-xs font-semibold uppercase tracking-wider text-ironside_grey dark:text-contrast-yellow">
        {{ 'ROUTE_FILTER_LABEL' | translate | uppercase }}
        <ng-container *ngIf="allowedRoutes?.length && showResetButton">
            :&nbsp;<span *ngFor="let route of allowedRoutes">
                {{ route.shortName }}
            </span>
        </ng-container>
    </p>
    <ion-button
        class="my-0 -mr-2 h-12 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
        *ngIf="showResetButton"
        (click)="resetAllowedRoutes()"
        fill="clear">
        <ion-icon
            class="mr-1 text-lg dark:filter-yellow"
            src="{{ assetsPath$ | async }}/img/journey-planner/icon-reset.svg"></ion-icon>
        {{ 'RESET_FILTER' | translate }}
    </ion-button>

    <button
        class="mt-4 flex h-11 items-center justify-center whitespace-nowrap p-0 text-xs font-semibold text-secondary"
        *ngIf="selectedRoutes.length !== 0 && !showResetButton"
        [attr.aria-label]="'SELECT_ROUTES' | translate"
        (click)="toggleRoutesModal()"
        fill="clear">
        {{ 'SELECT_ROUTES' | translate }}
    </button>
</div>

<form class="my-4" *ngIf="routes">
    <ul class="flex max-h-48 content-start gap-4 overflow-x-auto px-4 pb-4">
        <li
            class="flex h-10 min-w-[2.5rem] items-center justify-center rounded-full border-2 border-solid border-secondary bg-secondary font-bold text-white dark:border-contrast-yellow dark:bg-contrast-yellow dark:text-contrast-black"
            *ngIf="selectedRoutes.length === 0">
            {{ 'ALL' | translate }}
        </li>
        <ng-container *ngIf="selectedRoutes.length !== 0">
            <li
                class="flex h-10 items-center justify-center rounded-full border-2 border-solid border-[#838383]"
                *ngFor="let route of getSelectedRoutes()"
                [style.background-color]="routeColor(route)"
                [style.border-color]="routeColor(route)"
                [ngClass]="[route.shortName.length > 4 ? 'px-1' : 'min-w-[2.5rem]']">
                <label
                    class="whitespace-nowrap font-bold"
                    [htmlFor]="route.shortName"
                    [ngClass]="route.selected ? 'text-white dark:text-black' : 'text-[#838383]'">
                    {{ route.shortName }}
                </label>
                <input
                    class="sr-only"
                    [name]="route.shortName"
                    [title]="route.shortName"
                    [attr.aria-label]="route.shortName"
                    [attr.checked]="route.selected ? '' : null"
                    type="checkbox" />
            </li>
        </ng-container>

        <li *ngIf="selectedRoutes.length === 0">
            <button
                class="flex h-11 items-center justify-center whitespace-nowrap p-0 font-semibold text-secondary dark:text-contrast-yellow"
                [attr.aria-label]="'SELECT_ROUTES' | translate"
                (click)="toggleRoutesModal()"
                fill="clear">
                {{ 'SELECT_ROUTES' | translate }}
            </button>
        </li>
    </ul>
</form>
